import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset scroll position on client-side navigation (only
 * full page loads do that natively) — without this, clicking a link while
 * scrolled down lands on the new page still scrolled to the same spot.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
